(function () {
  var API_URL = 'https://agente-atencion.vercel.app/api/chat';
  var KAIRIA_URL = 'https://kairia.co';
  var COLOR_ACCENT = '#A9BE93';
  var COLOR_TEXT = '#2D2D2D';

  var mensajes = [];
  var cargando = false;
  var abiertoAlgunaVez = false;

  function el(tag, styles, attrs) {
    var node = document.createElement(tag);
    if (styles) Object.assign(node.style, styles);
    if (attrs) Object.keys(attrs).forEach(function (k) { node.setAttribute(k, attrs[k]); });
    return node;
  }

  // Animación de pulso para que la burbuja se note al cargar la página.
  var estilos = document.createElement('style');
  estilos.textContent =
    '@keyframes zenzooChatPulse{0%{box-shadow:0 4px 16px rgba(0,0,0,.2),0 0 0 0 rgba(169,190,147,.6)}70%{box-shadow:0 4px 16px rgba(0,0,0,.2),0 0 0 14px rgba(169,190,147,0)}100%{box-shadow:0 4px 16px rgba(0,0,0,.2),0 0 0 0 rgba(169,190,147,0)}}' +
    '.zenzoo-chat-pulse{animation:zenzooChatPulse 2s ease-out 3}';
  document.head.appendChild(estilos);

  // En celular y tablet el tema pinta una barra de navegación fija abajo
  // (Home/Shop/Search/Cart/Account): el botón quedaba encima de 'Account' y
  // el saludo tapaba el contenido. Se sube todo por encima de esa barra y el
  // saludo se achica y se retira solo.
  var esMovil = window.matchMedia('(max-width: 1023.98px)').matches;
  var BASE = esMovil ? 'calc(var(--bar-mobile-height, 0px) + 12px)' : '20px';
  var SOBRE_BOTON = esMovil ? 'calc(var(--bar-mobile-height, 0px) + 72px)' : '88px';
  var LADO = esMovil ? '50px' : '58px';

  var boton = el('button', {
    position: 'fixed', bottom: BASE, right: esMovil ? '12px' : '20px', width: LADO, height: LADO,
    borderRadius: '50%', background: COLOR_ACCENT, color: COLOR_TEXT, border: 'none',
    boxShadow: '0 4px 16px rgba(0,0,0,.2)', cursor: 'pointer', zIndex: '2147483000',
    display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '26px',
  }, { 'aria-label': 'Open Zenzoo chat', type: 'button' });
  boton.textContent = '🤖';
  boton.className = 'zenzoo-chat-pulse';

  var globito = el('div', {
    position: 'fixed', bottom: SOBRE_BOTON, right: esMovil ? '12px' : '20px', width: esMovil ? '220px' : '290px', maxWidth: 'calc(100vw - 32px)',
    background: '#fff', color: COLOR_TEXT, padding: esMovil ? '11px 13px' : '16px 18px', borderRadius: '18px',
    boxShadow: '0 10px 36px rgba(0,0,0,.28)', border: '2px solid ' + COLOR_ACCENT,
    fontSize: esMovil ? '13px' : '16px', fontWeight: '600', lineHeight: '1.45', zIndex: '2147483000', cursor: 'pointer',
    display: 'none',
  });
  var globitoTexto = el('span', {});
  globitoTexto.textContent = 'Hi! I\'m Zooey 💚 your personal shopper at Zenzoo. Need help finding your fit?';
  var globitoCerrar = el('button', {
    position: 'absolute', top: '-9px', right: '-9px', width: '24px', height: '24px', borderRadius: '50%',
    background: '#fff', border: '1px solid #ddd', color: COLOR_TEXT, fontSize: '13px', cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0',
  }, { 'aria-label': 'Close message', type: 'button' });
  globitoCerrar.textContent = '✕';
  globito.appendChild(globitoTexto);
  globito.appendChild(globitoCerrar);

  var panel = el('div', {
    position: 'fixed', bottom: SOBRE_BOTON, right: esMovil ? '12px' : '20px', width: '340px', maxWidth: 'calc(100vw - 24px)',
    height: '460px', maxHeight: esMovil ? 'calc(100vh - var(--bar-mobile-height, 0px) - 150px)' : 'calc(100vh - 130px)', background: '#fff', borderRadius: '16px',
    boxShadow: '0 8px 32px rgba(0,0,0,.25)', display: 'none', flexDirection: 'column',
    overflow: 'hidden', zIndex: '2147483000', fontFamily: 'inherit',
  });

  var header = el('div', {
    background: COLOR_ACCENT, color: COLOR_TEXT, padding: '14px 16px', fontWeight: '600',
    fontSize: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
  });
  header.innerHTML = '<span>Zooey &middot; Your personal shopper</span>';
  var cerrar = el('button', { background: 'transparent', border: 'none', fontSize: '18px', cursor: 'pointer', color: COLOR_TEXT }, { 'aria-label': 'Close chat', type: 'button' });
  cerrar.textContent = '✕';
  header.appendChild(cerrar);

  var lista = el('div', { flex: '1', overflowY: 'auto', padding: '14px', display: 'flex', flexDirection: 'column', gap: '10px', background: '#FAFAF8' });

  var formulario = el('form', { display: 'flex', borderTop: '1px solid #eee', padding: '10px' });
  var input = el('input', { flex: '1', border: '1px solid #ddd', borderRadius: '20px', padding: '8px 14px', fontSize: '14px', outline: 'none' }, { type: 'text', placeholder: 'Ask me anything...', 'aria-label': 'Message' });
  var enviar = el('button', { marginLeft: '8px', background: COLOR_ACCENT, color: COLOR_TEXT, border: 'none', borderRadius: '20px', padding: '8px 16px', fontSize: '14px', cursor: 'pointer', fontWeight: '600' }, { type: 'submit' });
  enviar.textContent = 'Send';
  formulario.appendChild(input);
  formulario.appendChild(enviar);

  var pie = el('div', { textAlign: 'center', padding: '5px 0 8px', fontSize: '11px', background: '#fff' });
  var pieLink = el('a', { color: COLOR_TEXT, textDecoration: 'underline', fontWeight: '600' }, { href: KAIRIA_URL, target: '_blank', rel: 'noopener noreferrer' });
  pieLink.textContent = 'Made by KairIA ↗';
  pie.appendChild(pieLink);

  panel.appendChild(header);
  panel.appendChild(lista);
  panel.appendChild(formulario);
  panel.appendChild(pie);

  function burbuja(texto, rol) {
    var esUsuario = rol === 'user';
    var fila = el('div', { display: 'flex', justifyContent: esUsuario ? 'flex-end' : 'flex-start' });
    var globo = el('div', {
      maxWidth: '80%', padding: '9px 13px', borderRadius: '14px', fontSize: '13.5px', lineHeight: '1.45',
      background: esUsuario ? COLOR_ACCENT : '#EFEFEA', color: COLOR_TEXT, whiteSpace: 'pre-wrap',
      // Sin esto, una URL larga sin espacios no parte de línea y se sale del globo.
      overflowWrap: 'anywhere', wordBreak: 'break-word', minWidth: '0',
    });
    globo.textContent = texto;
    fila.appendChild(globo);
    lista.appendChild(fila);
    lista.scrollTop = lista.scrollHeight;
    return globo;
  }

  function mensajeBienvenida() {
    if (lista.children.length === 0) {
      burbuja('Hi! I\'m Zooey 💚, your personal shopper at Zenzoo — here to help with sizing, shipping, returns, products, anything you need. I don\'t save your conversation.', 'assistant');
    }
  }

  // El saludo se muestra una sola vez por visita: antes volvía a salir en
  // cada página aunque la persona ya lo hubiera cerrado.
  var CLAVE_SALUDO = 'zenzoo-chat-saludo-visto';
  function saludoVisto() { try { return sessionStorage.getItem(CLAVE_SALUDO) === '1'; } catch (e) { return false; } }
  function ocultarSaludo() {
    globito.style.display = 'none';
    try { sessionStorage.setItem(CLAVE_SALUDO, '1'); } catch (e) {}
  }

  function abrir() {
    panel.style.display = 'flex';
    ocultarSaludo();
    boton.classList.remove('zenzoo-chat-pulse');
    abiertoAlgunaVez = true;
    mensajeBienvenida();
    input.focus();
  }

  boton.addEventListener('click', function () {
    var abierto = panel.style.display === 'flex';
    if (abierto) { panel.style.display = 'none'; } else { abrir(); }
  });
  cerrar.addEventListener('click', function () { panel.style.display = 'none'; });
  // En todo el globo, no solo el texto -- si no, clicks en el padding o
  // entre líneas del texto envuelto no abrían el chat (bug reportado por
  // Daniel probando en vivo).
  globito.addEventListener('click', abrir);
  globitoCerrar.addEventListener('click', function (ev) {
    ev.stopPropagation();
    ocultarSaludo();
  });

  // Globito de saludo que aparece solo para que la burbuja se note. En
  // computador se queda hasta que la persona lo cierre o abra el chat; en
  // celular se retira solo a los 7 segundos porque ahí tapa la página.
  setTimeout(function () {
    if (abiertoAlgunaVez || saludoVisto()) return;
    globito.style.display = 'block';
    if (esMovil) setTimeout(function () { if (!abiertoAlgunaVez) ocultarSaludo(); }, 7000);
  }, 2500);

  formulario.addEventListener('submit', function (ev) {
    ev.preventDefault();
    var texto = input.value.trim();
    if (!texto || cargando) return;

    burbuja(texto, 'user');
    mensajes.push({ role: 'user', content: texto });
    input.value = '';
    cargando = true;
    enviar.disabled = true;
    var globoCargando = burbuja('...', 'assistant');

    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ mensajes: mensajes.slice(-20) }),
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var texto = data.respuesta || data.error || 'Sorry, something went wrong. Please try again.';
        globoCargando.textContent = texto;
        mensajes.push({ role: 'assistant', content: texto });
      })
      .catch(function () {
        globoCargando.textContent = 'I couldn\'t connect. Please try again in a moment.';
      })
      .finally(function () {
        cargando = false;
        enviar.disabled = false;
        lista.scrollTop = lista.scrollHeight;
      });
  });

  function montar() {
    document.body.appendChild(boton);
    document.body.appendChild(globito);
    document.body.appendChild(panel);
  }

  document.addEventListener('DOMContentLoaded', montar);
  if (document.readyState !== 'loading') montar();
})();
